export const DEFAULT_SERVICE_TYPE = "neptune-db";
export const DEFAULT_FETCH_TIMEOUT = 240000;
export const DEFAULT_NODE_EXPAND_LIMIT = 500;
export const DEFAULT_CONCURRENT_REQUESTS_LIMIT = 10;

/** The name of the special property representing the node ID */
export const RESERVED_ID_PROPERTY = "~id";

/** The name of the property representing the list of types of the node */
export const RESERVED_TYPES_PROPERTY = "types";
export const RESERVED_ENTITY_NAME_PROPERTY = "entity_name";
export const RESERVED_DESCRIPTION_PROPERTY = "description";

/** The string "Graph Explorer". */
export const APP_NAME = "Graph Explorer";

/** The root URL for the app used for reloading fresh. */
export const RELOAD_URL =
  process.env.BASE_URL && process.env.BASE_URL.slice(-1) !== "/"
    ? process.env.BASE_URL + "/"
    : process.env.BASE_URL || "";

/** Shown when a value is missing */
export const MISSING_DISPLAY_VALUE = "---";
